import React, { useState } from "react";
import "./MarketingStyle.css";
import vision from "../../assets/vision.png";
import goals from "../../assets/Goals.png";
import { useTranslation } from "react-i18next";

const Marketing = ({ id }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToConsultation = () => {
    const consultationElement = document.getElementById("consultation-form");
    if (consultationElement) {
      consultationElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const whatsappNumbers = ["+201026252290", "+971569150318"];
  const whatsappMessage = encodeURIComponent(t("marketing.whatsappMessage"));

  const handleWhatsAppClick = () => {
    setIsModalOpen(true);
  };

  const handleNumberSelect = (number) => {
    const whatsappLink = `https://wa.me/${number}?text=${whatsappMessage}`;
    window.open(whatsappLink, "_blank", "noopener,noreferrer");
    setIsModalOpen(false);
  };

  return (
    <section className="marketing-section-container" id={id}>
      <div className="container">
        <h2 className="marketing-section-title">{t("marketing.title")}</h2>
        <div className="marketing-section-content">
          <div className="marketing-section-card marketing-section-card-top-left">
            <img
              src={vision}
              alt={t("marketing.vision.title")}
              className="marketing-section-image"
            />
            <div className="vision-text-container">
              <h3 className="marketing-section-card-title">
                {t("marketing.vision.title")}
              </h3>
              <p className="marketing-section-text">
                {t("marketing.vision.description")}
              </p>
            </div>
          </div>

          <div className="marketing-section-card marketing-section-card-bottom-right">
            <div className="goals-text-container">
              <h3 className="marketing-section-card-title">
                {t("marketing.goals.title")}
              </h3>
              <p className="marketing-section-text">
                {t("marketing.goals.description")}
              </p>
            </div>
            <img
              src={goals}
              alt={t("marketing.goals.title")}
              className="marketing-section-image"
            />
          </div>
        </div>

        <div className="marketing-section-buttons">
          <button
            onClick={scrollToConsultation}
            className="marketing-section-button"
            aria-label="View our consultation plan"
          >
            {t("marketing.buttons.plan")}
          </button>
          <button
            onClick={handleWhatsAppClick}
            className="marketing-section-button"
            aria-label="Contact us on WhatsApp"
          >
            {t("marketing.buttons.whatsapp")}
          </button>
        </div>

        {isModalOpen && (
          <div className="whatsapp-modal-overlay">
            <div className="whatsapp-modal-container">
              <h3>{t("marketing.selectNumber")}</h3>
              {whatsappNumbers.map((number) => (
                <button
                  key={number}
                  onClick={() => handleNumberSelect(number)}
                  className="whatsapp-modal-number-button"
                >
                  {number}
                </button>
              ))}
              <button
                onClick={() => setIsModalOpen(false)}
                className="whatsapp-modal-cancel-button"
              >
                {t("marketing.cancel")}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Marketing;
